import * as monaco from "monaco-editor";
import { registerStdoutLanguage } from "./stdoutLanguage";
import * as suggestions from "./solLanguageSuggestions";
export function registerSolLanguage(monaco) {
    monaco.languages.register({ id: "solLanguage" });
    var keywords = suggestions.getKeywords();
    var functionsKeywords = suggestions.getFunctionsKeywords();
    var datesKeywords = suggestions.getDatesKeywords();
    var dateNapeosKeywords = suggestions.getFunctionsKeywords();
    var listKeywords = suggestions.getListKeywords();
    var typeKeywords = suggestions.getTypeKeywords();
    var booleanKeywords = suggestions.getBooleanKeywords();
    monaco.languages.setMonarchTokensProvider("solLanguage", {
        keywords: keywords,
        functionsKeywords: functionsKeywords,
        datesKeywords: datesKeywords,
        dateNapeosKeywords: dateNapeosKeywords,
        listKeywords: listKeywords,
        typeKeywords: typeKeywords,
        booleanKeywords: booleanKeywords,
        operators: [
            "=",
            ">",
            "<",
            "!",
            "~",
            "?",
            ":",
            "==",
            "<=",
            ">=",
            "!=",
            "&&",
            "||",
            "++",
            "--",
            "+",
            "-",
            "*",
            "/",
            "&",
            "|",
            "^",
            "%",
            "<<",
            ">>",
            ">>>",
            "+=",
            "-=",
            "*=",
            "/=",
            "&=",
            "|=",
            "^=",
            "%=",
            "<<=",
            ">>=",
            ">>>=",
        ],
        escapes: /\\(?:[abfnrtv\\"']|x[0-9A-Fa-f]{1,4}|u[0-9A-Fa-f]{4}|U[0-9A-Fa-f]{8})/,
        tokenizer: {
            root: [
                [
                    /[a-z_$][\w$]*/,
                    {
                        cases: {
                            "@keywords": "keyword",
                            "@functionsKeywords": "keyword",
                            "@datesKeywords": "keyword",
                            "@dateNapeosKeywords": "keyword",
                            "@listKeywords": "keyword",
                            "@typeKeywords": "keyword",
                            "@booleanKeywords": "keyword",
                            "@default": "identifier",
                        },
                    },
                ],
                [/[A-Z][\w\$]*/, "type.identifier"],
                { include: "@whitespace" },
                [/\d{4}[\/]\d{2}[\/]\d{2}/, "keyword"],
                [/\d{2}[\:]\d{2}[\:]\d{2}/, "keyword"],
                [/\d*\.\d+([eE][\-+]?\d+)?/, "number.float"],
                [/0[xX][0-9a-fA-F]+/, "number.hex"],
                [/\d+/, "number"],
                [/[,]/, "delimiter"],
                [/"([^"\\]|\\.)*$/, "string.invalid"],
                [/"/, { token: "string.quote", bracket: "@open", next: "@string" }],
                [/#.*$/, "comment"],
            ],
            string: [
                [/[^\\"]+/, "string"],
                [/@escapes/, "string.escape"],
                [/\\./, "string.escape.invalid"],
                [/"/, { token: "string.quote", bracket: "@close", next: "@pop" }],
            ],
            whitespace: [[/[ \t\r\n]+/, "white"]],
        },
    });
    return monaco;
}
export const monacoWithSol = registerStdoutLanguage(registerSolLanguage(monaco));
//# sourceMappingURL=solLanguage.js.map